import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { goToAnchor, removeHash, configureAnchors } from 'react-scrollable-anchor'
import {
  Button, Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

import './header.scss';
import logo from '../../assets/images/logo.svg';

class Header extends Component {

  constructor(props) {
    super(props);
    configureAnchors({ scrollDuration: 500 })
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }


  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div className="header-container">
        <Navbar color="faded" light expand="md" className="container-fluid fixed-top">
          <div className="container">
            <NavbarBrand className="mr-auto navbar-brand" href="/"><img src={logo} alt="logo" /></NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem className="nav-item">
                  <NavLink className="nav-link primary-font" href="/#about-us">About us</NavLink>
                </NavItem>
                <NavItem className="nav-item">
                  <NavLink className="nav-link primary-font" href="/#our-projects">Our Projects</NavLink>
                </NavItem>
                <NavItem className="nav-item">
                  <NavLink className="nav-link primary-font" href="/#our-services">Our Services</NavLink>
                </NavItem>
                <NavItem className="nav-item">
                  <NavLink onClick={() => { this.props.history.push('/career'); }} className="nav-link primary-font">Career</NavLink>
                </NavItem>
                <NavItem className="nav-item">
                  <Button className="button-contact" onClick={() => { this.props.history.push('/contact'); }} color="primary">Contact us</Button>
                </NavItem>
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      </div>
    )
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js